import { call, put } from "redux-saga/effects";
import { api } from "../../../services";
import { Creators } from "./index";

import { Alerts } from "../../../lib";

export default function* unblockUserAssociated({ data, callback }) {
  try {
    yield call(api.unblockUserAmcred, data);

    yield put(Creators.newUserAssociatedSuccess());

    callback();
  } catch (response) {
    Alerts.alertError(
      response?.data?.log
        ? response?.data?.log
        : "Não foi possível desbloquear o usuário",
      1
    );

    yield put(Creators.newUserAssociatedFailure());
  }
}
